'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _FormattedReactionCount = require('./FormattedReactionCount');

var _FormattedReactionCount2 = _interopRequireDefault(_FormattedReactionCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ownProps = arguments[1];
  var contentReactions = state.reaction.contentReactions;

  if (!contentReactions || !ownProps.communityContentId) {
    return {};
  }

  var contentIdString = ownProps.communityContentId.type + '-' + ownProps.communityContentId.relatedId;
  var ownContentReactions = contentReactions[contentIdString];
  if (!ownContentReactions) return {};

  var reactions = 0;
  ownContentReactions.existingReactions.forEach(function (reactionType) {
    reactions += ownContentReactions.reactions[reactionType].count;
  });

  return {
    reactions: reactions
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_FormattedReactionCount2.default);